export { StaticPageHelper } from './staticPageHelper';
export * from './interfaces';